import { ModuleWidget, SOFTLINE_WIDGET_OUTLET_DASHBOARD } from '@softapps/core';

// Widget registrations — loaded when a matching widget-outlet renders
// (federation) or re-provided via provideKundeninfoWidget by the legacy composition.
export function dashboardWidgets(): ModuleWidget[] {
  return [
    {
      outletNames: [SOFTLINE_WIDGET_OUTLET_DASHBOARD],
      group: 'allgemein',
      loadComponent: () =>
        import('./widgets/kundeninfo-widget/kundeninfo-widget.component').then(
          (m) => m.KundeninfoWidgetComponent
        ),
      permission: 'KONTENABFRAGE.KONTOINFO.WIDGET',
    },
  ];
}
